import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { usePoster } from '../PosterContext';

const POSTER_SRC = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/poster7.png";
const POSTER_TITLE = "浴門神社";
const POSTER_DESC = "峰迴路轉 大快人心";

const VARIANT_SRC = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/poster7v.jpg";
const VARIANT_DESC = "望穿秋水 七步成濕";

const PosterModal7 = ({ isOpen, onClose }) => {
  const [showVariant, setShowVariant] = useState(false);

  const { isGameEnabled } = usePoster();

  useEffect(() => {
    if (isGameEnabled) {
      const img = new Image();
      img.src = VARIANT_SRC;
    }
  }, [isGameEnabled]);

  useEffect(() => {
    if (isOpen && isGameEnabled) {
      const openCount = parseInt(sessionStorage.getItem('posterModal7_openCount') || '0');
      const newCount = openCount + 1;

      sessionStorage.setItem('posterModal7_openCount', newCount.toString());

      if (newCount >= 7) {
        setShowVariant(true);
      }
    }
  }, [isOpen, isGameEnabled]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center transition-all"
      style={{
        backgroundImage: `url('/img/goty2024/hero-bricks.png')`,
        backgroundRepeat: 'repeat',
        backgroundColor: 'rgba(0,0,0,0.90)',
      }}
      onClick={onClose}
    >
      <button
        className="absolute top-4 right-4 text-white text-3xl font-bold z-60"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        aria-label="關閉"
      >
        ×
      </button>
      <div
        className="flex flex-col items-center justify-between relative"
        onClick={e => e.stopPropagation()}
      >
        <div
          className="w-[calc(100%+2rem)] md:w-[calc(100%+4rem)] bg-[#DFB750] text-center border-x-8 border-b-8 border-solid border-black mr-[-1rem] ml-[-1rem] md:mr-[-2rem] md:ml-[-2rem]"
        >
          <h2 className="text-2xl md:text-3xl font-bold tracking-wide text-black py-2 md:py-4">
            {POSTER_TITLE}
          </h2>
        </div>
        <div className="relative w-80 md:w-auto h-auto md:h-[75vh]">
          <img src={showVariant ? VARIANT_SRC : POSTER_SRC} alt={POSTER_TITLE} className="object-contain w-full h-full mx-auto border-x-8 border-b-8 border-solid border-black shadow-2xl" />
        </div>
        <div className="mt-6 text-center">
          <p className={clsx("text-xl md:text-2xl font-bold tracking-widest shadow-2xl", {
            'text-white': !isGameEnabled,
            'text-black': isGameEnabled
          })}>
            {isGameEnabled ? VARIANT_DESC : POSTER_DESC}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PosterModal7;
